import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { impactData } from "../data/mock";
import { SectionReveal } from "./SectionReveal";

const ImpactCard = ({ item, index, isVisible }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8, y: 30, filter: "blur(10px)" }}
    animate={isVisible ? { opacity: 1, scale: 1, y: 0, filter: "blur(0px)" } : {}}
    transition={{ duration: 0.7, delay: index * 0.12, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -4, transition: { duration: 0.2 } }}
    className="bg-white dark:bg-zinc-900/40 border border-zinc-200 dark:border-zinc-800/50 rounded-xl p-6 text-center hover:border-emerald-300 dark:hover:border-emerald-500/20 transition-colors duration-300 shadow-sm dark:shadow-none"
  >
    <motion.div
      className="text-2xl sm:text-3xl font-bold text-emerald-600 dark:text-emerald-400 font-mono"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={isVisible ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.6, delay: index * 0.12 + 0.3, type: "spring", stiffness: 200 }}
    >
      {item.value}
    </motion.div>
    <p className="text-zinc-600 dark:text-zinc-400 text-sm font-medium mt-1">{item.suffix}</p>
    <p className="text-zinc-400 dark:text-zinc-600 text-xs mt-3 leading-relaxed">{item.description}</p>
  </motion.div>
);

const ImpactSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section className="relative py-28 lg:py-36 bg-white dark:bg-zinc-950 transition-colors duration-500" ref={sectionRef}>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-px bg-gradient-to-r from-transparent via-zinc-300/60 dark:via-zinc-800/60 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionReveal animation="blurIn">
          <div className="text-center mb-16">
            <span className="text-sm font-mono text-emerald-600/80 dark:text-emerald-400/80 tracking-widest uppercase">Impact</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-zinc-900 dark:text-zinc-50 tracking-tight">Building at scale</h2>
          </div>
        </SectionReveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {impactData.map((item, i) => (
            <ImpactCard key={item.label} item={item} index={i} isVisible={isInView} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
